import React, {useCallback, useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {getDate} from "../../redux/slice/dateSlice";
import {
    getInDecreaseRateOfError,
    getKeepingRate,
    getMaintenancece,
    getMaintenanceceDetail,
    getTaskCalendar,
} from "../../api/static/StaticService";
import {getRequestBulletin, getRequestNotice} from "../../api/static/StaticRequestService";
import ManagedTaskStatic from "../chart/ManagedTaskStatic";
import ManagedAssetStatic from "../chart/ManagedAssetStatic";
import TaskHandleCurrentStatic from "../chart/TaskHandleCurrentStatic";
import TaskComplyRateStatic from "../chart/TaskComplyRateStatic";
import TaskCalendar from "../chart/TaskCalendar";
import {TotalNotice} from "../chart/TotalNotice";
import {TotalBulletin} from "../chart/TotalBulletin";
import {DailyErrorRateCard, MonthlyErrorRateCard} from "../chart/TotalErrorRateCards";


const extractResponseData = (result) => {
    if (result.status !== "fulfilled") return null;
    const response = result.value;
    if (response?.status === 200) return response.data;
    return null;
};

function DashBoardTotal() {
    const user = useSelector((state) => state.auth.user);
    const maintenanceQuery = useSelector((state) => getDate(state, "유지관리 업무현황"));
    const calendarSearch = useSelector((state) => getDate(state, "업무달력"));
    const keepRateSearch = useSelector((state) => getDate(state, "업무준수율"));
    const monthlyErrorSearch = useSelector((state) => getDate(state, "월간 장애비율"));

    const [loading, setLoading] = useState(true);
    const [dashboardData, setDashboardData] = useState({
        maintenance: null,
        assetDetail: null,
        calendar: null,
        keepingRate: null,
        errorRate: null,
        bulletin: null,
        notice: null,
    });

    const fetchDashboard = useCallback(async () => {
        setLoading(true);

        const [
            maintenanceResult,
            assetDetailResult,
            calendarResult,
            keepingRateResult,
            errorRateResult,
            bulletinResult,
            noticeResult,
        ] = await Promise.allSettled([
            getMaintenancece(maintenanceQuery),
            getMaintenanceceDetail(),
            getTaskCalendar(calendarSearch),
            getKeepingRate(keepRateSearch),
            getInDecreaseRateOfError(monthlyErrorSearch),
            getRequestBulletin("main"),
            getRequestNotice("main"),
        ]);

        setDashboardData({
            maintenance: extractResponseData(maintenanceResult),
            assetDetail: extractResponseData(assetDetailResult),
            calendar: extractResponseData(calendarResult),
            keepingRate: extractResponseData(keepingRateResult),
            errorRate: extractResponseData(errorRateResult),
            bulletin: extractResponseData(bulletinResult),
            notice: extractResponseData(noticeResult),
        });
        setLoading(false);
    }, [maintenanceQuery, calendarSearch, keepRateSearch, monthlyErrorSearch]);

    useEffect(() => {
        fetchDashboard();
    }, [fetchDashboard]);

    return (
        <div className="common-container flex min-h-0 flex-col">
            <p className="shrink-0 text-[24px]">안녕하세요. {user.name}님,</p>
            <p className="mb-4 shrink-0 text-[24px]">스마트한 자동화 프로세스로 업무효율을 높여보세요!</p>

            <div
                className="flex flex-col gap-4 md:grid md:min-h-0 md:flex-1 md:[grid-template-columns:minmax(0,3fr)_minmax(0,5fr)_minmax(0,2fr)] md:[grid-template-rows:minmax(0,2fr)_minmax(0,2fr)_minmax(0,1.5fr)]"
            >
                <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                    <ManagedTaskStatic
                        data={dashboardData.maintenance}
                        loading={loading}
                    />
                </div>
                <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                    <ManagedAssetStatic
                        data={dashboardData.assetDetail?.data}
                        loading={loading}
                    />
                </div>
                <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                    <TaskCalendar
                        data={dashboardData.calendar}
                        loading={loading}
                    />
                </div>
                <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                    <TaskHandleCurrentStatic />
                </div>
                <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                    <TaskComplyRateStatic
                        data={dashboardData.keepingRate}
                        loading={loading}
                    />
                </div>
                <div className="flex flex-col gap-4 md:grid md:min-h-0 md:grid-rows-2">
                    <DailyErrorRateCard
                        data={dashboardData.errorRate}
                        loading={loading}
                    />
                    <MonthlyErrorRateCard
                        data={dashboardData.errorRate}
                        loading={loading}
                    />
                </div>
                <div
                    className="flex flex-col gap-4 md:col-span-3 md:grid md:min-h-0 md:grid-cols-[minmax(0,7fr)_minmax(0,3fr)]"
                >
                    <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                        <TotalNotice
                            data={dashboardData.notice}
                            loading={loading}
                        />
                    </div>
                    <div className="flex min-h-[320px] flex-col overflow-hidden border rounded-si p-[16px] md:h-full md:min-h-0">
                        <TotalBulletin
                            data={dashboardData.bulletin}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashBoardTotal;
